var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empadronamiento__intro__main"},[_c('div',{staticClass:"empadronamiento__intro__main__form"},[_c('div',{staticClass:"empadronamiento__intro__main__form__container"},[_c('h2',[_vm._v(_vm._s(_vm.errorMessage))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }